import Entity from './Entity.js'
import Vector from '../Vector.js'
import Size from '../Size.js'

class Bullet extends Entity {
    
    constructor(id, radius, position) {
        super();
        this.id = id;
        this.radius = radius;
        this.position = position;
    }
    
    getId() {
        return this.id
    }
    
    setRadius(radius) {
        this.radius = radius;
        return this;
    }
    
    getRadius() {
        return this.radius;
    }
    
    tick() {
        super.tick()
    }
    
    draw(ctx) {
        super.draw(ctx)
        
        const position = this.getPosition();
        ctx.beginPath();
        ctx.arc(position.getX(), position.getY(), this.radius, 0, 2 * Math.PI, false);
        //context.fillStyle = 'green';
        ctx.fill();
      //context.lineWidth = 5;
      //context.strokeStyle = '#003300';
      //context.stroke();
    }
    
}

export default Bullet
